/**
 * Where the list's links go. Import and Manage categories open their dialogs on the list itself (2E); an import's
 * result in the bell opens the list, where the banner shows it (R19).
 */
export const CONTACTS_HREF = "/households";
/** Today's Settings page, at the "Advanced settings" area (it opens itself when reached by this address, 2E F7). */
export const CONTACT_SETTINGS_HREF = "/settings#advanced-settings";
export const NEW_CONTACT_HREF = "/households/create";
export const contactHref = (id: number) => `/households/update/household-info/${id}`;
/** Edit contact, opened at a field (`focus=home`: the home address, e.g. from an address problem to approve, 2D). */
export const contactEditHref = (id: number, focus?: "home") => `${contactHref(id)}${focus ? `?focus=${focus}` : ""}`;
/**
 * The contact page (2C). While it is switched off, today's side of this address sends a numeric id on to
 * `contactHref`, so the list's name links can point here already.
 */
export const contactPageHref = (id: number) => `/households/${id}`;
/** The contact's history of changes (2C). */
export const changesHref = (id: number) => `/households/${id}/changes`;
/** 2F: the combine page for a pair ("Compare and combine"); the first id stays unless the page swaps them. */
export const combineHref = (id: number, otherId: number) => `/households/${id}/combine/${otherId}`;

/**
 * The visit report and the visit history open over the page the user is on (2D, R16): `?report=<id>[&point=<id>]`
 * and `?history=<id>` on the current path, read by `ReportLauncherProvider`. The page's own search is kept (the
 * list's filters and page), and another launcher param is replaced: one dialog at a time.
 */
export type Here = { pathname: string; search: string };
export const LAUNCH_PARAMS = ["report", "point", "history"];
export const withoutLaunch = (search: string): string => {
  const p = new URLSearchParams(search);
  LAUNCH_PARAMS.forEach((k) => p.delete(k));
  const out = p.toString();
  return out ? `?${out}` : "";
};
const launchHref = (here: Here, set: [string, number][]) => {
  const p = new URLSearchParams(withoutLaunch(here.search));
  set.forEach(([k, v]) => p.set(k, String(v)));
  return `${here.pathname}?${p.toString()}`;
};
/** The row's "Report", the contact's "Report a visit", and links from reminders or a route stop (`pointId`). */
export const reportHref = (id: number, here: Here, pointId?: number) =>
  launchHref(here, pointId !== undefined ? [["report", id], ["point", pointId]] : [["report", id]]);
/** The ⋯ "Visit history", the contact's "Visit history" and the history of changes' "See report". */
export const historyHref = (id: number, here: Here) => launchHref(here, [["history", id]]);

/** What a link into the contact page carries, so its ✕ / Back return to the list as it was (search, filters, page). */
export type ContactLinkState = { listSearch?: string };
export const contactLinkState = (search: string): ContactLinkState => ({ listSearch: search });
